import MessageReaction from '@components/messages/MessageReaction'
import styled from '@emotion/styled'
import { size } from '@styles/theme'
import { useEffect, useRef, useState } from 'react'

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  height: ${size(3.5)};
`

// Used the merge new values into the count index such that they are ordered by oldest created to newest created
const merge = (val, arr) => {
  const newArr = []
  let didPush = false
  arr.forEach((reaction) => {
    if (!didPush && val.createdAt < reaction.createdAt) {
      newArr.push(val)
      didPush = true
    }
    newArr.push(reaction)
  })
  if (!didPush) newArr.push(val)
  return newArr
}

const formatMessageReactions = (messageReactions) => {
  const frequencyCounter = {}
  const countIndex = []
  const formattedArr = []

  // First we make the frequency counter to get the total count of each emoji
  messageReactions.forEach(({ emoji, createdAt }) => {
    if (frequencyCounter[emoji]) {
      frequencyCounter[emoji].count ++
      if (createdAt) {
        const newCreated = new Date(createdAt)
        frequencyCounter.createdAt = newCreated < frequencyCounter.createdAt ? newCreated : frequencyCounter.createdAt
      }
    } else {
      frequencyCounter[emoji] = {
        count: 1,
        createdAt: createdAt ? new Date(createdAt) : new Date()
      }
    }
  })

  // Next we turn the frquency counter into an index by the count, so we can iterate map through each reaction in the proper order
  Object.entries(frequencyCounter).forEach(([key, value]) => {
    if (!value?.count) return;
    if (countIndex[value.count]) {
      countIndex[value.count] = merge({ emoji: key, createdAt: value.createdAt }, countIndex[value.count])
    } else {
      countIndex[value.count] = [{ emoji: key, createdAt: value.createdAt }]
    }
  })

  // Essentially a flatmap, we reverse iterate through the count index and push each item into the formatted array as we go
  for (let i = countIndex.length - 1; i >= 0; i--) {
    if(countIndex[i]) {
      countIndex[i].forEach((val) => {
        formattedArr.push({ count: i, emoji: val.emoji })
      })
    }
  }

  // return your hard won results
  return formattedArr
}

const MessageReactionList = ({ messageReactions, bubbleRef, isOwnMessage }) => {
  const [positionLeft, setPositionLeft] = useState(false)
  const [containerEl, setContainerEl] = useState(null)
  const [reactions, setReactions] = useState([])

  // Update message reactions being rendered whenever the message reactions update
  useEffect(() => {
    setReactions(formatMessageReactions(messageReactions))
  }, [messageReactions])

  // Updates whether or not the reactions should align to the left
  useEffect(() => {
    setPositionLeft(!isOwnMessage && containerEl && bubbleRef && containerEl?.offsetWidth > bubbleRef?.offsetWidth)
  }, [containerEl, bubbleRef, reactions])

  return (
    <Container ref={node => { node && setContainerEl(node)}} style={{ position: 'absolute', bottom: size(-1.5), [positionLeft ? 'left' : 'right']: size(1), }}>
      {reactions.map((reaction, index) => <MessageReaction key={index} reaction={reaction} />)}
    </Container>
  )
}

export default MessageReactionList
